import { handleActions } from 'redux-actions'
import {
  bookingAddService,
  bookingRemoveService,
  bookingSelectDay,
  bookingSelectHour,
  bookingReset,
  bookingSetUserData
} from './actions'
import { availabilitiesStartLoading } from '../availability/actions'

const getDefaultState = () => ({
  services: [],
  selectedDay: null,
  selectedHour: null,
  userData: null
})

export const reducer = handleActions(
  {
    [bookingAddService]: (state, { payload }) => ({
      ...state,
      services: [
        ...state.services.filter(s => s.gruppoWeb !== payload.gruppoWeb),
        payload
      ]
    }),
    [bookingRemoveService]: (state, { payload }) => ({
      ...state,
      services: state.services.filter(service => service.id !== payload.id)
    }),
    [bookingSelectDay]: (state, { payload }) => ({
      ...state,
      selectedDay: payload,
      selectedHour: null
    }),
    [bookingSelectHour]: (state, { payload }) => ({
      ...state,
      selectedHour: payload
    }),
    [bookingSetUserData]: (state, { payload }) => ({
      ...state,
      userData: payload
    }),
    [bookingReset]: () => getDefaultState(),
    [availabilitiesStartLoading]: state => ({
      ...state,
      selectedDay: null,
      selectedHour: null
    })
  },
  getDefaultState()
)
